/**
 * @name Mask-Email
 * @function
 * @param {string} email
 *  Plane text email string
 * @returns {string} Masked Email
 * @description
 *  This function will create a 5.2 filter mask on any email passed in
 *  5.2 = 5 max characters 2 of which are masked with '*'
 * @example
 *  const email1 = "john.doe@sbcglobal.com"
 *  const email2 = "doe@sbcglobal.com"
 *  maskEmail(email1) => "joh**@sbcglobal.com"
 *  maskEmail(email2) => "d**@sbcglobal.com"
 */
const maskEmail = email => {
  if (!email) {
    return null;
  }
  const [id, domain] = email.split('@');
  const emailId = id.length >= 5 ? id.substring(0, 5) : id;
  const idLength = emailId.length;
  const unmaskedLength = idLength > 3 ? 3 : Math.ceil(idLength * 0.3);
  const unmaskedId = emailId.substring(0, unmaskedLength);
  const maskedId = unmaskedId.padEnd(idLength, '*');

  return `${maskedId}@${domain}`;
};

export default maskEmail;
